import { API_ENDPOINT_V1 } from "config/api.config";

const API_ENDPOINT = API_ENDPOINT_V1;

export const BROKER_ENDPOINT = {
  postLoginBroker: {
    url: `${API_ENDPOINT}/api/login`,
    method: "POST",
  },
  postLogoutBroker: {
    url: `${API_ENDPOINT}/api/logout`,
    method: "POST",
  },
  getListCategory: {
    url: `${API_ENDPOINT}/api/list-category`,
    method: "GET",
  },
  getCategoryDetails: (id) => ({
    url: `${API_ENDPOINT}/api/get-list/${id}`,
    method: "GET",
  }),
  getPropertyImages: (id, roomId) => ({
    url: `${API_ENDPOINT}/api/property-images/${roomId}/${id}`,
    method: "GET",
  }),
  getAmenitiesCategoryDetails: (id) => ({
    url: `${API_ENDPOINT}/api/get-list/${id}`,
    method: "GET",
  }),
  meeting: {
    url: `${API_ENDPOINT}/api/meeting`,
    method: "POST",
  },
};
